import axiosInstance from "../axiosInstance";

export const inventoryRiskService = {
  // One warehouse per request — the API refuses to answer without one.
  fetch: async (params, { signal } = {}) => {
    const response = await axiosInstance.get("/inventory-risk", {
      params,
      signal,
      suppressErrorToast: true,
    });
    return response.data;
  },
  // Product drawer: the product's SKU rows from the dashboard's cached dataset.
  fetchProduct: async (productId, params, { signal } = {}) => {
    const response = await axiosInstance.get(
      `/inventory-risk/${encodeURIComponent(productId)}`,
      { params, signal, suppressErrorToast: true },
    );
    return response.data;
  },
  // One SKU's inventory + sales history, loaded only when a SKU is selected.
  fetchHistory: async (params, { signal } = {}) => {
    const response = await axiosInstance.get("/inventory-risk-history", {
      params,
      signal,
      suppressErrorToast: true,
    });
    return response.data;
  },
};
